/**
 * Created by claude on 17.02.2026
 */

const SeasonCollectionsHelper = function (view, season) {
    this.view = view;
    this.season = season || cleverapps.stickersBook.season;
};

SeasonCollectionsHelper.prototype.getCollectionIcon = function (index) {
    return bundles.stickers_book_window.frames[`season_${this.season}_collection_${index}_png`];
};

SeasonCollectionsHelper.prototype.getStickerImage = function (collectionIndex, stickerIndex) {
    return bundles[SeasonCollectionsHelper.getCollectionBundleName(collectionIndex, this.season)]
        .frames[`sticker_${stickerIndex}_png`];
};

SeasonCollectionsHelper.prototype.getSeasonBundle = function () {
    return bundles[SeasonCollectionsHelper.getSeasonBundleName(this.season)];
};

SeasonCollectionsHelper.prototype.getCollectionBundle = function (index) {
    return bundles[SeasonCollectionsHelper.getCollectionBundleName(index, this.season)];
};

SeasonCollectionsHelper.getCollectionBundleName = function (index, season) {
    return `season_${season}_collection_${index}`;
};

SeasonCollectionsHelper.getSeasonBundleName = function (season) {
    return `stickers_book_season_${season}`;
};

SeasonCollectionsHelper.hasCollectionBundle = function (index, season) {
    return !!bundles[SeasonCollectionsHelper.getCollectionBundleName(index, season)];
};

SeasonCollectionsHelper.hasSeasonBundle = function (season) {
    return !!bundles[SeasonCollectionsHelper.getSeasonBundleName(season)];
};
